export default __webpack_public_path__ + "static/media/ramp_walkthrough_0.e80d35a8.bin";